import type {ReactElement} from 'react';
import React from 'react';
import {noop} from '@Utils/general.util';
import {IconBox} from '../icon-box';
import {Tag} from '../tag';
import styles from './icon-box-with-tag.module.scss';

interface IconBoxWithTagProps {
  iconBoxClasses?: string;
  tagClasses?: string;
  className?: string;
  tagText: string;
  icon: string;
  iconBoxText: string;
  onClick?(): void;
  disabled?: boolean;
  isSelected?: boolean;
  position?: TAG_POSITION;
}

export enum TAG_POSITION {
  LEFT = 'left',
  RIGHT = 'right',
}

export function IconBoxWithTag({
  iconBoxClasses = '',
  tagClasses = '',
  className = '',
  onClick = noop,
  disabled = false,
  position = TAG_POSITION.RIGHT,
  ...props
}: IconBoxWithTagProps): ReactElement {
  const onClickHandler = (): void => {
    if (onClick && !disabled) {
      onClick();
    }
  };

  const getTagContainerClasses = (): string => {
    const classes = [styles.tagContainer];

    if (position === TAG_POSITION.LEFT) {
      classes.push(styles.left);
    } else if (position === TAG_POSITION.RIGHT) {
      classes.push(styles.right);
    }

    return classes.join(' ');
  };

  return (
    <div className={`${styles.iconBoxWithTagsContainer} ${className}`}>
      <div className={getTagContainerClasses()}>
        <Tag className={tagClasses} text={props.tagText} />
      </div>
      <IconBox
        onClick={onClickHandler}
        className={`${iconBoxClasses} ${disabled ? styles.disabledState : ''}`}
        isSelected={props.isSelected}
        icon={props.icon}
        text={props.iconBoxText}
      />
    </div>
  );
}
